import React, { Component } from 'react';
import Search from '../Home/Search';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { Collapse } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { appService } from '../../_services'
import { faIR } from 'date-fns/esm/locale';
import DocumentMeta from 'react-document-meta';
import { Accordion } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { FaChevronUp } from 'react-icons/fa';
import { FaChevronDown } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import EmailModal from 'react-bootstrap/Modal'
import { Redirect, Route } from 'react-router-dom';
var CountAC = 0, CountHK = 0, CountLQ = 0, CountRZ = 0, CountDG = 0;
let options1 = '', options2 = '', Itemid = '', parameters = ""
var setpadding = { paddingLeft: '8%' }



var cardbodystyle = {
    border: '1px solid #CCCCCC',
    height: '300px',
    overflowY: 'scroll'
}
export class ManageAccount extends Component {
    displayName = ManageAccount.name
    constructor(props) {
        super(props);
        this.state = {
            redirectToLogin: false
        }
        this.handleEtocModalShow = this.handleEtocModalShow.bind(this);
        this.handleEtocModalClose = this.handleEtocModalClose.bind(this);
        this.logoutsession = this.logoutsession.bind(this);
    }
     
    logoutsession() {

        var self = this;
        if (localStorage.getItem('user') !== null) {
            appService.getAll('/User/logOutDecreseActiveCount').then(function (response) {
                appService.getAll('/User/logOut').then(function (response) {

                    //localStorage.removeItem('user');
                    //localStorage.removeItem('userId');
                    //localStorage.removeItem('usersubscription');
                    //localStorage.removeItem('company');
                    //localStorage.removeItem('firstName');
                    //localStorage.removeItem('lastName');
                    //localStorage.removeItem('salesForceID');
                    localStorage.clear();
                    localStorage.setItem('logoutclick', 'true');

                });
                window['LastURL'] = '';
            });

        }
        self.setState({
            redirectToLogin: true
        })
    }  
    handleEtocModalClose() {
        this.setState({ handleEtocModalShow: false });
    }

    handleEtocModalShow() {
        this.setState({ handleEtocModalShow: true });
    }
    render() {
        if (this.state.redirectToLogin) {
            this.setState({ redirectToLogin: false });
            return <Redirect to={"/Login"} />
        }
        const meta = {
            title: "Kluwer Law Online - Manage Account",
            canonical: window.location.href,
        }

        return (
            <DocumentMeta {...meta}>
                <div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-lg-9">
                                <p className="TitlePadding Title"> Manage my Personal account</p>
                                 
                                <span className="TitlePadding green-heading"> <Link to="/ChangePassword"> Change password</Link></span>
                            </div>
                            <EmailModal show={this.state.handleEtocModalShow} onHide={this.handleEtocModalClose}  {...this.props}
                                size="lg"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered>
                                <EmailModal.Header closeButton className="Popupcolor">
                                    <Modal.Title>
                                        Table of Contents alert (ETOC)
                                            </Modal.Title>
                                </EmailModal.Header>
                                <EmailModal.Body>
                                    <div>
                                        <div className="row mt-6 AllColPadding">
                                            <div className="col-lg-6 TopicPadding">
                                                <label>Sign up for ETOC alerts to receive an e-mail informing you when new content for Kluwer Law Online prodcuts is available online. Login or create an account and select the title(s) you wish to subscribe to.</label>

                                            </div>
                                        </div>

                                    </div>
                                </EmailModal.Body>
                                <EmailModal.Footer>
                                    <div className="row AllColPadding">

                                        <div className="col-sm-4 TopicPadding">

                                            <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.logoutsession}>  Login/Create Account </span>
                                        </div>
                                        <div className="col-sm-8 TopicPadding ">
                                            <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEtocModalClose}>  Return to site </span>
                                        </div>
                                    </div>
                                </EmailModal.Footer>
                            </EmailModal>

                        </div>
                        <br></br>
 
                        <div className="White">
                        </div>
                    </div >
                </div>
            </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/ManageAccount.jsx